import { render } from "./MitigationTasksModal.vue?vue&type=template&id=d1c1a35c&scoped=true"
import script from "./MitigationTasksModal.js?vue&type=script&lang=js"
export * from "./MitigationTasksModal.js?vue&type=script&lang=js"

import "./MitigationTasksModal.vue?vue&type=style&index=0&id=d1c1a35c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c1a35c"]])

export default __exports__